export const enums = {
  DEFAULT: 'Default',
  PRODUCT: 'Colorway',
  TAG_DEFINITION_NAME: 'Tags',
  MATERIAL: 'materials',
  COLORS: 'colors',
  SKETCH: 'sketches',
  STATUS: {
    PENDING: 'Pending',
    PUBLISHED: 'Published'
  },
  COLORWAY_CARRYOVER: 'ColorwayCarryOver',
  COLORWAY_SAMPLE: 'ColorwaySample',
  COLORWAY_PRICE: 'ColorwayPrice',
  COLORWAY_QUANTITY: 'ColorwayQuantity',
  FABRIC: 'Fabric',
  TAG_TYPE_TAG: 'Tag',
  MERCH_OPTION_TAG_TYPE_TAG: 'MerchOptionVersionTag',
  MERCH_OPTION_TAG_DEFINITION_NAME: 'attributes.MerchOptionVersionTags',
  MERCH_OPTION_VERSION_TAG_DEFINITION_NAME: 'attributes.MerchOptionVersionTags'
}

export enum Keys {
  BACKSPACE = 8,
  TAB = 9,
  ENTER = 13,
  SHIFT = 16,
  ESCAPE = 27,
  SPACE = 32,
  PAGE_UP = 33,
  PAGE_DOWN = 34,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  DELETE = 46
}


// WEBPACK FOOTER //
// ./src/modules/enums.ts